import React from 'react';
import { Flex, Text } from '@radix-ui/themes';
import { cn, formatCurrency } from '@/lib/utils';
import Link from 'next/link';
import { AuctionWithRevenue } from './api/revenue/route';
import { NoSsr } from '@mui/material';
import { format } from 'date-fns';
interface Props {
  auction: AuctionWithRevenue;
}

const RecentAuctionRow = ({ auction }: Props) => {
  return (
    <Link href={`/admin/auctions/${auction.id}/settings`}>
      <Flex className="p-2 mb-2 items-center">
        <div className="w-9 h-9 rounded-full bg-slate-300 flex items-center justify-center text-white mr-4">
          <span className="text-xl text-slate-900">◈</span>
        </div>
        <Flex direction="column" className="flex-grow">
          <Text className="font-medium">{auction.title}</Text>
          <NoSsr>
            <Text className="text-gray-500">{`${format(auction.startDate, "dd MMM, yyyy")} - ${format(auction.endDate, "dd MMM, yyyy")}`}</Text>
          </NoSsr>
        </Flex>
        <AuctionRevenue revenue={auction.revenue} />
      </Flex>
    </Link>
  );
}

const AuctionRevenue = ({ revenue }: { revenue: number }) => {
  // How can revenue ever be negative? 
  // It probably can't be, but we'll check for it just in case. 
  return <Text className="font-medium text-slate-900">
    {`+${formatCurrency(revenue, true, 2)}`}
  </Text>
}

export default RecentAuctionRow;
